/*
 * Copyright © 2021-present Protonbase Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Protonbase Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Protonbase Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { UserOutlined, SkinOutlined } from '@ant-design/icons'
import { Space, TableColumnsType } from 'antd'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { CommonRole } from 'account-client'
import { RevokeRoleFromUser } from '@/pages/auth/features/RevokeRoleFromUser'
import { TRoleName, TRoleType } from '@/pages/auth/interface'
import { timeFormatter } from '@/utils/timeFormatter'

export function useRoleUsersColumns(role: TRoleName) {
  const { t } = useTranslation()

  const columns = useMemo<TableColumnsType<CommonRole>>(
    () => [
      {
        title:t('Members'),
        dataIndex: 'name',
        render: (value, record) => (
          <Space>
            {record.type === TRoleType.role ? <SkinOutlined /> : <UserOutlined />}
            {value}
          </Space>
        ),
      },
      {
        title: t('Granted at'),
        dataIndex: 'gmtCreated',
        render: date => timeFormatter.format(date),
      },
      // {
      //   title: t('Authorizer'),
      // },
      {
        title: t('Actions'),
        dataIndex: 'name',
        width: 150,
        render: (value, record) =>
          record.type === TRoleType.user && <RevokeRoleFromUser style="button" roleType={TRoleType.user} role={role} userName={value} />,
      },
    ],
    [],
  )

  return columns
}
